module.exports = __webpack_public_path__ + "img/main_banner_video.503fd96b.png";